import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import Immutable from 'immutable';

import rootReducer from '../reducers/reducer';

const initial = {
  ui: {},
};

const configureStore = (initialState = Immutable.fromJS(initial)) => {
  const finalCreateStore = applyMiddleware(thunk)(createStore);
  return finalCreateStore(rootReducer, initialState);
};

export default configureStore;
